'use strict'
const BarsOrdering = (targetBar) => {
  /*
  * Priority order what bar should be shown first
  * */
  const ordering = [
    'cookieAgreement',
    'renderSignAgreementNotification',
    'tipForDesigner'
  ]
  /*
  * True/false status for each bar. Order matches those on top
  * */
  const status = [
    !Cookies.get(gon.cookies_map.cookies_policy_closed),
    !!App.config.renderSignAgreementNotification,
    !!App.config.tipForDesigner
  ]
  const findActiveBar = (elem) => { return elem === true } // Callback to retrieve position of first `true` active bar
  const findBarPosition = (elem) => { return elem === targetBar } // Callback to retrieve priority of targetBar

  if (targetBar && App.config[targetBar]) {
    return status.findIndex(findActiveBar) === ordering.findIndex(findBarPosition)
  }

  return false
}

export default BarsOrdering
